//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect } from 'react';

// === COMPONENTS ===
import { FileProvider } from '../FileContext/FileContext';
import { DropProvider } from 'components/DragDrop/DropContext';
import { Panel } from '../Panel';
import Styled from 'components/Styled/Styled';

// === HOOKS ===
import { useLayout } from '../Panel/PanelContext';

//#endregion

//-----------------------------------------------------------------
export function FileView() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { save } = useLayout();

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    // Save any changes to the local layout when leaving the page
    return () => {
      save();
    }
  }, [] );

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{height: 'calc( 100% - 60px )'}]}>
        <FileProvider>
          <DropProvider>
            <Panel id={1} />
          </DropProvider>
        </FileProvider>
      </Styled>
    )
  }

  //#endregion

  return display();
}